import 'script-loader!jquery/dist/jquery.min';
import 'script-loader!moment/moment';
import 'script-loader!moment-timezone/builds/moment-timezone-with-data';
import 'script-loader!progressbar.js/dist/progressbar';

import 'script-loader!./src/js/jquery.beatswitch.timeline';
import './index.scss';
